import React from 'react';
import {
	LIMIT_EXCEEEDED,
	XLXS_FILE_TYPE,
	MAX_ROW_COUNT,
	MAX_CSV_ROW_COUNT
} from 'constants/constant';
import reportSettingStyles from '../ReportSettings.style';
import { Box, FormControlLabel, Radio, InputLabel, Tooltip } from '@material-ui/core';

const RadioField = (props) => {
	const { item, rowCount = undefined, file = undefined } = props;
	const classes = reportSettingStyles();

	const radioBtn = (val) => {
		return (
			<FormControlLabel
				key={val.label}
				id={val.label}
				className={classes.radio}
				value={val.label}
				disabled={val.disabled}
				control={<Radio color="primary" tabIndex="0" id={`${val.label}-radio`} />}
				label={
					<Box className={classes.radioLabelBox}>
						<InputLabel className={classes.radioText} disabled={val.disabled}>
							{val.label}
						</InputLabel>
						{rowCount > MAX_ROW_COUNT &&
							rowCount < MAX_CSV_ROW_COUNT &&
							file === XLXS_FILE_TYPE &&
							val.label === XLXS_FILE_TYPE && (
								<InputLabel className={classes.radioWarning}>{LIMIT_EXCEEEDED}</InputLabel>
							)}
					</Box>
				}
			/>
		);
	};

	return item.map((val) => {
		return val.tooltip ? (
			<Tooltip
				title={val.tooltip.text}
				placement={val.tooltip.placement}
				arrow
				classes={{ arrow: classes.arrow, tooltip: classes.radioTooltip }}>
				<span>{radioBtn(val)}</span>
			</Tooltip>
		) : (
			radioBtn(val)
		);
	});
};

export default RadioField;
